import { Observable, of } from 'rxjs/index';
import Event from '../../core/Event';
import { ofType, StateObservable } from 'redux-observable';
import api from '../../core/api';
import { catchError, map, mergeMap } from 'rxjs/internal/operators';
import { AjaxError } from 'rxjs/internal/observable/dom/AjaxObservable';
import RequestFailed from '../../core/events/RequestFailed';
import State from '../../core/State';
import { AjaxBackend } from '../../testHelpers/fakeBackendFactory';
import RemoveCustomerConfirmed from '../../estimations/events/RemoveCustomerConfirmed';
import CustomersRequested from '../events/CustomersRequested';

export default (event$: Observable<Event>, state$: StateObservable<State>, backend: AjaxBackend): Observable<Event> =>
    event$.pipe(
        ofType(RemoveCustomerConfirmed.type),
        mergeMap((confirmed: RemoveCustomerConfirmed) =>
            backend.delete(`${api()}customers/` + confirmed.customerId).pipe(
                map(() => new CustomersRequested()),
                catchError((e: AjaxError) => of(new RequestFailed(e.status)))
            )
        )
    );



// WEBPACK FOOTER //
// ./src/application/admin/epic/customersDelete.ts